import { render, staticRenderFns } from "./select-date.vue?vue&type=template&id=01b489be&"
import script from "./select-date.vue?vue&type=script&lang=js&"
export * from "./select-date.vue?vue&type=script&lang=js&"
import style0 from "./select-date.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./select-date.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports